import gql from 'graphql-tag'

export const getCompaniesData = gql`
  query DooerComGetCompanies($q: String!) {
    publicCompanySearch(q: $q) {
      name
      organizationNumber
      displayOrganizationNumber
      legalgroupCode
      city
    }
  }
`
